import { Box, Select } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Control, Controller } from 'react-hook-form';

import { AboutFormData } from '../../types';
import { TilliggendeRom } from '../../../../../utils/registerEnums';

interface AdjoiningRoomSelectProps {
  control: Control<AboutFormData>;
}

export const AdjoiningRoomSelect: FC<AdjoiningRoomSelectProps> = ({ control }) => {
  const { t } = useTranslation();

  const options = [
    {
      disabled: true,
      label: t('register.adjoiningRooms.option.defaultFirstStoryFloor'),
      value: -1
    },
    ...[
      TilliggendeRom.MotDetFri,
      TilliggendeRom.MotGrunn,
      TilliggendeRom.OppvarmetRom,
      TilliggendeRom.UoppvarmetRom,
      TilliggendeRom.Krypkjeller,
      TilliggendeRom.Ukjent
    ].map((option) => ({
      label: t(`register.adjoiningRooms.option.${option}`),
      value: option
    }))
  ];

  return (
    <Controller
      control={control}
      shouldUnregister={true}
      name="bygginfo.basementAdjoiningRoom"
      rules={{
        required: t('register.adjoiningRooms.option.defaultFirstStoryFloor')
      }}
      render={({ field: { value, onChange, ...rest }, fieldState: { error } }) => (
        <Box display="inline-block">
          <Select
            label={t('register.bygningsdetaljer.tilliggendeRomGulvIForsteEtasje.label')}
            HelperBoxProps={{
              'aria-label': t('readFieldInformation'),
              children: t('register.bygningsdetaljer.tilliggendeRomGulvIForsteEtasje.information')
            }}
            fullWidth
            options={options}
            value={value ?? -1}
            onChange={({ currentTarget: { value: val } }) => onChange(val)}
            error={!!error}
            helperText={error && t(`${error.message}`)}
            {...rest}
          />
        </Box>
      )}
    />
  );
};
